import { render, staticRenderFns } from "./ContactNotesModal.vue?vue&type=template&id=794f5d74&scoped=true"
import script from "./ContactNotesModal.vue?vue&type=script&lang=js"
export * from "./ContactNotesModal.vue?vue&type=script&lang=js"
import style0 from "./ContactNotesModal.vue?vue&type=style&index=0&id=794f5d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f5d74",
  null
  
)

export default component.exports